import { rem as polishedRem } from 'polished';
export function rem(value) {
    return polishedRem(value);
}
export function toRemString(values) {
    return values.map((value) => rem(value)).join(' ');
}
//# sourceMappingURL=units.js.map